<template>
<div>
    <SearchBox ref="SearchBox">
        <el-form slot="form" :inline="true" ref="searchParams" :model="userParam" label-width="80px" class="unitWidth" size="small">
            <el-form-item :label="$t('base.name')">
                <el-input v-model.trim="userParam.userName" :placeholder="$t('User.input')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('base.JobNo')">
                <el-input v-model.trim="userParam.userAccount" :placeholder="$t('User.input')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('base.email')">
                <el-input v-model.trim="userParam.userEmail" :placeholder="$t('base.PleaseEnter')"></el-input>
            </el-form-item>
            <!--<el-form-item label="手机号码">
                <el-input v-model.trim="userParam.userPhone" placeholder="请输入手机号码"></el-input>
            </el-form-item>-->
            <el-form-item>
                <el-button type="primary" @click="addUser">{{$t('base.confirm')}}</el-button>
                <el-button type="primary" @click="addUserRoleShow">{{$t('User.AddRole')}}</el-button>
            </el-form-item>
        </el-form>
    </SearchBox>
    <div class="tableBox">
        <el-table
            :data="userRolesList"
            style="width: 100%">
            <el-table-column
                :label="$t('base.order')"
                type="index"
                width="70">
            </el-table-column>
            <el-table-column
                :label="$t('User.RoleName')"
                width="170"
                prop="roleName">
            </el-table-column>
            <el-table-column
                :label="$t('User.RoleLevel')"
                width="170"
                prop="roleName">
            </el-table-column>
            <el-table-column
                :label="$t('Shift.factory')"
                width="170"
                prop="factoryName">
            </el-table-column>
            <el-table-column
                :label="$t('User.workshop')"
                width="170"
                prop="label">
            </el-table-column>
            <el-table-column
                :label="$t('User.section')"
                width="170"
                prop="vsmName">
            </el-table-column>
            <el-table-column
                :label="$t('User.productLine')"
                width="170"
                prop="lineName">
            </el-table-column>
            <el-table-column :label="$t('base.operation')" width="180">
                <template slot-scope="scope">
                    <i class="delBtn iconfont u-shanchu" @click="deleterole(scope)"/>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <el-dialog
        :visible.sync="dialogVisible"
        width="30%">
        <el-form :inline="true" :model="userRoles" ref="userForm" label-width="100px" class="fform">
            <el-form-item :label="$t('Shift.factory')">
                <el-select v-model="fcIdSelected" :disabled="ischeck" filterable @change="fcChange" :placeholder="$t('base.PleaseSelect')">
                    <el-option
                        v-for="factory in factoryList"
                        :key="factory.value"
                        :label="factory.label"
                        :value="factory.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('User.RoleName')">
                <el-select v-model="roleIdSelected" :placeholder="$t('base.PleaseSelect')" filterable>
                    <el-option
                        v-for="role in roleList"
                        :key="role.roleId"
                        :label="role.roleName"
                        :value="JSON.stringify(role)">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('User.workshop')" v-if="hasShopSelect">
                <el-select v-model="shopSelected" :placeholder="$t('base.PleaseSelect')" filterable>
                    <el-option
                        v-for="shop in shopList"
                        :key="shop.value"
                        :label="shop.label"
                        :value="shop.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('User.section')" v-if="hashSectionSelect">
                <el-select v-model="sectionSelected" :placeholder="$t('base.PleaseSelect')" filterable>
                    <el-option
                        v-for="section in sectionList"
                        :key="section.value"
                        :label="section.label"
                        :value="section.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('User.productLine')" v-if="hashLineSelect">
                <el-select v-model="lineSelected" :placeholder="$t('base.PleaseSelect')" filterable>
                    <el-option
                        v-for="line in lineList"
                        :key="line.value"
                        :label="line.label"
                        :value="line.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{$t('base.cancel')}}</el-button>
            <el-button type="primary" @click="addUserRole">{{$t('base.confirm')}}</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
    import { listRole } from '../../../libs/api'

    export default {
        name: 'addUser',
        data(){
            return{
                userParam:{},
                userRolesList: [],
                dialogVisible:false,
                userRoles:{},
                roleList:[],
                factoryTree: [],
                fcIdSelected: '',
                roleIdSelected: '',
                sectionSelected: '',
                shopSelected: '',
                lineSelected: '',
                ischeck:true,
                role:[]
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr;
            },
            shopList: function() {
                var arr = []
                if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                    var factory = JSON.parse(this.fcIdSelected)
                    var shops = factory.child
                        for (var i = 0; i < shops.length; i++) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.shopSelected != undefined && this.shopSelected.length > 0) {
                    var shop = JSON.parse(this.shopSelected)
                    var vsms = shop.child
                        for (var i = 0; i < vsms.length; i++) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                    var vsm = JSON.parse(this.sectionSelected)
                    var lines = vsm.child
                        for (var i = 0; i < lines.length; i++) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                    }
                }
                return arr
            },
            hasShopSelect: function() {
                if(this.roleIdSelected.length > 0) {
                    var role = JSON.parse(this.roleIdSelected)
                    if("shop" == role.roleLevel || "vsm" == role.roleLevel||"line" == role.roleLevel)
                        return true
                }
                return false
            },
            hashSectionSelect: function() {
                if(this.roleIdSelected.length > 0) {
                    var role = JSON.parse(this.roleIdSelected)
                    if("vsm" == role.roleLevel||"line" == role.roleLevel)
                        return true
                }
                return false
            },
            hashLineSelect: function() {
                if(this.roleIdSelected.length > 0) {
                    var role = JSON.parse(this.roleIdSelected)
                    if("line" == role.roleLevel)
                        return true
                }
                return false
            }
        },
        created() {
            this.init()
        },
        methods:{
            init(){
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if(role[i].factoryId == 0){
                        this.ischeck = false;
                        this.role = role[i]
                        break;
                    }else{
                        if(this.userInfo.factoryId == role[i].factoryId){
                            this.role = role[i]
                        }
                    }
                }
                this.getData()
            },
            /*getRoleFcCode(){
                var fcCode = JSON.parse(this.roleIdSelected).fcCode
                for (var i = 0; i < this.factoryTree.length; i++) {
                    if(this.factoryTree[i].deptCode == fcCode){
                        this.fcIdSelected = JSON.stringify(this.factoryTree[i])
                    }
                }
            },*/
            fcChange(){
                this.shopSelected = ''
                this.sectionSelected = ''
                this.lineSelected = ''
                this.roleIdSelected = ''
                this.getRoles()
            },
            addUser(){
                var self = this
                if(self.userParam.userName == null || self.userParam.userName == ''){
                    self.$message.error(this.$t('User.name'))
                    return
                }
                if(self.userParam.userAccount == null || self.userParam.userAccount == ''){
                    self.$message.error(this.$t('User.JobNo'))
                    return
                }
                if(self.userRolesList == null || self.userRolesList.length == 0) {
                    self.$message.error(this.$t('User.create'))
                    return
                }
                var queryData = {
                    userName:self.userParam.userName,
                    userAccount:self.userParam.userAccount,
                    userPhone:self.userParam.userPhone,
                    userEmail:self.userParam.userEmail,
                    roles:self.userRolesList
                }
                let options = {
                    method: 'POST',
                    data: queryData,
                    url: this.$api.userSave
                }
                this.$http.request(options).then(response => {
                    console.log(response)
                    if(response.data){
                        self.$message.success(this.$t('base.SuccessfullyAdded'))
                        this.$router.push({ path: '/User' })
                    }else{
                        self.$message.error(response.message)
                    }
                })
            },
            addUserRoleShow(){
                this.dialogVisible = true
            },
            getRoles(){
                var params = {}
                if(this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }else{
                    return
                }
                let options = {
                    method: 'GET',
                    url: this.$api.listRole,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if(response.status == 100) {
                        this.roleList = []
                        if(this.ischeck == false){
                            this.roleList = response.data
                        }else{
                            var aa = response.data
                            for (let i = 0; i < aa.length; i++) {
                                if(aa[i].roleCode != 'admin'){
                                    this.roleList.push(aa[i])
                                }
                            }
                        }
                    }
                })
            },
            addUserRole(){
                var self = this
                var role = {
                    roleName: JSON.parse(self.roleIdSelected).roleName,
                    roleId: JSON.parse(self.roleIdSelected).roleId,
                    factoryId: JSON.parse(self.fcIdSelected).deptID,
                    factoryName: JSON.parse(self.fcIdSelected).deptName,
                    fcCode: JSON.parse(self.fcIdSelected).deptCode
                }
                if(JSON.parse(self.roleIdSelected).roleLevel == 'shop') {
                    role['shopId'] = JSON.parse(self.shopSelected).deptID
                    role['label'] = JSON.parse(self.shopSelected).deptName
                    role['shopCode'] = JSON.parse(self.shopSelected).deptCode
                }
                if(JSON.parse(self.roleIdSelected).roleLevel == 'vsm') {
                    role['shopId'] = JSON.parse(self.shopSelected).deptID
                    role['label'] = JSON.parse(self.shopSelected).deptName
                    role['shopCode'] = JSON.parse(self.shopSelected).deptCode
                    role['vsmId'] = JSON.parse(self.sectionSelected).deptID
                    role['vsmName'] = JSON.parse(self.sectionSelected).deptName
                    role['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                }
                if(JSON.parse(self.roleIdSelected).roleLevel == 'line') {
                    role['shopId'] = JSON.parse(self.shopSelected).deptID
                    role['label'] = JSON.parse(self.shopSelected).deptName
                    role['shopCode'] = JSON.parse(self.shopSelected).deptCode
                    role['vsmId'] = JSON.parse(self.sectionSelected).deptID
                    role['vsmName'] = JSON.parse(self.sectionSelected).deptName
                    role['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                    role['lineId'] = JSON.parse(self.lineSelected).deptID
                    role['lineName'] = JSON.parse(self.lineSelected).deptName
                    role['lineCode'] = JSON.parse(self.lineSelected).deptCode
                }
                for(var i = 0; i < self.userRolesList.length; i++) {
                    if(self.userRolesList[i].roleId == role.roleId &&
                        self.userRolesList[i].factoryId == role.factoryId &&
                        self.userRolesList[i].shopId == role.shopId &&
                        self.userRolesList[i].vsmId == role.vsmId &&
                        self.userRolesList[i].lineId == role.lineId) {
                        self.$message.error(this.$t('User.added'))
                        return
                    }
                }
                /*for(var i = 0; i < self.userRolesList.length; i++) {
                    if(self.userRolesList[i].factoryId != role.factoryId){
                        self.$message.error("用户只能一个工厂")
                        return
                    }
                }*/
                self.dialogVisible = false
                self.userRolesList.push(role)
            },
            deleterole(scope){
                this.userRolesList.splice(scope.$index, 1)
            },
            getData(){
                let options = {
                    method: 'GET',
                    url : this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < this.factoryTree.length; i++) {
                        if(this.factoryTree[i].deptID == this.role.factoryId){
                            this.fcIdSelected = JSON.stringify(this.factoryTree[i])
                        }
                    }
                    this.getRoles()
                })
            }
        }
    }
</script>

<style scoped>

</style>
